import Component from 'inferno-component';
import BalloonGame from '../BalloonGame/BalloonGame';
import '../Utils/PrettyButton.css';
import './ResumeView.css';
import './ResumeViewMobile.css';

class ResumeView extends Component {
  render() {
    return (
      <div className='resume-view' ref={(el) => { this.frame = el; }}>
        <header className="resume-view-header">
          <div className="header-content">
            <h1>Jacek Pakulski</h1>
            <ul className="contact-details">
              <li className="row title">
                Creative Developer
              </li>
              <li className="row phone">
                <a href="tel:+64-21-048-0355">+64 21 048 0355</a>
              </li>
              <li className="row email indented">
                <a href="mailto:j@megdrive.com" alt="Click to send me an email" target="_blank">j@megdrive.com</a>
              </li>
              <li className="row linkedin indented">
                <a href="https://www.linkedin.com/in/jacek-pakulski" alt="Click to view my linkedin profile" target="_blank">linkedin.com/in/jacek-pakulski</a>
              </li>
              <li className="row web indented">
                <a href="https://megdrive.com" alt="Click to view my website / blog" target="_blank">megdrive.com</a>
              </li>
              <li className="row">
                <a href="https://goo.gl/maps/F9a1thLV24N2" target="_blank" alt="Click to view Tauranga on a map">Tauranga</a>, New Zealand
              </li>
            </ul>
          </div>
        </header>
        <section className="cover-letter">
          <h2>
            Cover Letter
            <BalloonGame />
          </h2>
          <div className="resume-content">
            <p>
              I have more than 20 years experience working as a developer and a bit more than that working in the tech industry.
            </p>
            <p>
              I’m happiest when I’m creating and this is how I fill my spare time, whether it’s web development, visualising data, hardware programming, or woodworking.
            </p>
            <p>
              I've used many technologies over the years, but love learning new things, usually by incorporating them in new projects. I'm using Elixir, Phoenix and Elm for my beekeeping reporting dashboard project.
            </p>
            <p>
              Please get in touch so we can talk about how I can help with your development needs.
            </p>
          </div>
        </section>
        <section className="education">
          <h2>Education</h2>
          <div className="resume-content">
            <div className="row">
              <div className="place">University of Ottawa</div>
              <div className="when">Graduated December, 2000</div>
              <div className="what">Bachelor Of Applied Science in Electrical Engineering</div>
            </div>
            <div className="row">
              <div className="place">University of Ottawa</div>
              <div className="when">-</div>
              <div className="what">Bachelor Of Computer Science</div>
              <em className="explanation">
                I almost finished, but my work at the time got too interesting and demanding and the courses were anything but.
              </em>
            </div>
          </div>
        </section>
        <section className="experience">
          <h2>
            Experience
            <a className="pretty-button" href="https://www.linkedin.com/in/jacek-pakulski" target="_blank">
              <i className="icon-linkedin"></i>
              LinkedIn
            </a>
          </h2>
          <div className="resume-content timeline">
            <div className="row">
              <header>
                <span className="daterange">08/2015 - 08/2017</span>
                <span className="place">Pinnacle Ltd.</span>
              </header>
              <div className="description">
                I made few dashboards, a few tools, enhanced a CRM and tried to help wherever I could.
                I learned lots of medical stuff in the process.
                Most importantly I got access to vast quantities of amazing data to play with.
                For the last year, I was the sole developer, which was a unique experience.
                I worked mostly with Ruby, Rails, Ember, D3, PostgreSQL and SQL Server.
                I did sneak a little C#, Go and Elixir work. Even antique VB got some love (or hate).
              </div>
            </div>
            <div className="row">
              <header>
                <span className="daterange">01/2012 - 08/2015</span>
                <span className="place">Digital Dialogue</span>
              </header>
              <div className="description">
                For a while we had the dream team. Awesome developers, an awesome system administrator, managment that cared.
                We worked well together and learned lots from each other. Most of the work involved working with Ruby, Rails, Ember, Angular, D3 and PostgreSQL.
                Early on we used Rhodes to create several 'native' applications for iOS.
              </div>
            </div>
            <div className="row">
              <header>
                <span className="daterange">09/2009 - 12/2011</span>
                <span className="place">Zeevo</span>
              </header>
              <div className="description">
                I helped develop lots of websites mostly using PHP, CodeIgniter and ModX with nothing but jQuery on the front-end.
              </div>
            </div>
            <div className="row">
              <header>
                <span className="daterange">01/2009 - 05/2009</span>
                <span className="place">Panztel Ltd.</span>
              </header>
              <div className="description">
                I improved a large Ruby on Rails application. My role had me focusing on the UI and UX experience.
              </div>
            </div>
            <div className="row">
              <header>
                <span className="daterange">08/2007 - 12/2008</span>
                <span className="place">Cohesion Communications</span>
              </header>
              <div className="description">
                I programmed PHP-based websites mostly using vanilla Javascript on the front-end. Flash and ActionScript got a bit of use as well.
              </div>
            </div>
            <div className="row">
              <header>
                <span className="daterange">05/2003 - 08/2007</span>
                <span className="place">Quake Technologies</span>
              </header>
              <div className="description">
                I developed interfaces for configuring, testing and demonstrating our chips, initially using TCL/TK then switching to Python and wxWidgets.
                I wrote firmware for microcontrollers (Atmel) on our evaluation boards in C and assembly.
                I dabbled in a bit of hardware programming with System C.
              </div>
            </div>
          </div>
        </section>
        <section className="skills">
          <h2>
            Skills
            <button className="skills-dashboard pretty-button" onClick={ this.props.viewToggle }>
              <i className="icon-stats-bars"></i>
              Skills Dashboard
            </button>
            <button className="random-project pretty-button" onClick={ this.props.showRandomProject }>
              <i className="icon-shuffle"></i>
              Show Random Project
            </button>
          </h2>
          <div className="resume-content">
            <dl>
              <dt>Ruby & Ruby on Rails</dt>
              <dd>I've worked on many Rails projects big and small. It's my go to platform for getting something done fast.</dd>
              <dt>Ruby & Sinatra</dt>
              <dd>The go to stack for API development.</dd>
              <dt>Elixir & Phoenix</dt>
              <dd>What I'm trying to become more proficcient at. I want this to be my go to server-side stack.</dd>
              <dt>Ember</dt>
              <dd>My go to front-end framework for large projects.</dd>
              <dt>AngularJS</dt>
              <dd>
                I was not too happy when working with Angular 1 and consequently helped convince the team to use Ember.
                However, I'm reading <a href="https://pragprog.com/book/dcbang2/rails-angular-postgres-and-bootstrap-second-edition" target="_blank">this</a> rather awesome book which will hopefully convince me to give Angular 4 a chance.
              </dd>
              <dt>React, Inferno, Preact, Vue...</dt>
              <dd>I use various frameworks on smaller projects in hope of finding the <strong>one</strong>. For example, this website is written using Inferno. The quest continues.</dd>
              <dt>PHP & CodeIgniter</dt>
              <dd>This was my favourite server-side stack before I switched to Rails.</dd>
              <dt>PostgreSQL</dt>
              <dd>My relational database of choice. I have tried or worked with other databases and types of databases, e.g., InfluxDB (time series database), Redshift (optimised for large volumes of data), MongoDB and Redis (NoSQL).</dd>
              <dt>Swift & Objective C</dt>
              <dd>I figured it's good to know the native way of making applications for iOS before using something like RubyMotion or React Native.</dd>
            </dl>
          </div>
        </section>
        <section className="interests">
          <h2>Interests</h2>
          <div className="resume-content">
            Wife, kids, running, guitar, photography, programming, making stuff, oh and we just got a dog, so dog.
          </div>
        </section>
        <section className="references">
          <h2>References</h2>
          <div className="resume-content">
            Please see my <a href="https://www.linkedin.com/in/jacek-pakulski" target="_blank">LinkedIn</a> profile.
          </div>
        </section>
      </div>
    );
  }
}

export default ResumeView;



// WEBPACK FOOTER //
// ./src/ResumeView/ResumeView.js